import { Component, Input, OnInit, signal } from '@angular/core';
import { Alarm } from 'app/classes/alarm';
import { AlarmService } from "../../../shared/alarm.service";
import { StoreService } from 'app/shared/store.service';

@Component({
  selector: 'app-rulesv3-item-alarm-timeline',
  templateUrl: './rulesv3-item-alarm-timeline.component.html',
  styleUrls: ['./rulesv3-item-alarm-timeline.component.css'],
  standalone: false
})
export class Rulesv3ItemAlarmTimelineComponent implements OnInit {

  _alarm: Alarm;
  @Input()
  public set alarm(v: Alarm) {
    this._alarm = v;
    if (v) {
      this.doWork();
    }
  }

  public get alarm(): Alarm {
    return this._alarm;
  }

  timeline = signal<{ icon: string, words: string, date: Date, connector: string, colour: string, name: string, logo: string }[]>(null);

  validTimelineItems = signal<any[]>(null);

  constructor(private alarmService: AlarmService, private storeService: StoreService) { }

  ngOnInit(): void {
  }

  doWork() {
    const theme = this.storeService.getTheme();
    this.timeline.set([]);
    let findings, history;
    if (!this.alarm.findings) {
      const response = this.alarmService.getHistory(this.alarm.timeline);
      this.alarm.findings = response.findings;
      this.alarm.history = response.history;
    }

    findings = this.alarm.findings;
    history = this.alarm.history;

    if (this.alarm.history) {
      const validAlarms = this.alarm.history.filter(i => i.action);
      this.validTimelineItems.set(validAlarms);
      const timelineItems = [];
      for (let index = 0; index < validAlarms.length; index++) {
        const item = validAlarms[index];

        let icon = '';
        let logo = null;
        let words = item.value;
        let colour = theme === 'light' ? 'black' : 'white';
        switch (item.action) {
          case 'state_change':
            switch (item.value) {
              case 'new':
                words = 'Alarmed';
                icon = 'mdi-bell-alert-outline';
                colour = 'red';
                break;
              case 'acknowledged':
                if (item.name) {
                  words = `Acknowledged`;
                } else {
                  words = 'Acknowledged';
                }
                icon = 'mdi-account';
                colour = 'blue';
                break;
              case 'resolved':
                words = this.alarm.findings.text;
                icon = 'mdi-check';
                colour = 'green';
                break;
              case 'paused':
              case 'pause':
                words = 'Paused';
                icon = 'mdi-pause';
                colour = 'orange';
                break;
            }
            if (item.notes) {
              words += ` <q>${item.notes}</q>`;
            }
            break;
          case 'notes':
            icon = 'mdi-note-edit-outline';
            colour = 'black';
            words = `<q>${words}</q>`;
            break;
          case 'email':
            words = 'Emailed ' + item.value;
            icon = 'mdi-email-fast-outline';
            break;
          case 'elogbook_job':
            words = 'Elogbooks job #' + item.value;
            icon = null;
            logo = 'elogbooks';
            break;
          case 'operate':
            words = 'Operate equipment - ' + item.value;
            icon = 'mdi-toggle-switch-variant-off';
            colour = 'red';
            break;
        }
        let connector = '|';
        if (index === validAlarms.length - 1) {
          connector = '';
        } else {

        }
        timelineItems.push({ icon, words, date: item.createdAt, connector, colour, name: item.name, logo });
      }
      this.timeline.set(timelineItems);
    }
  }
}
